import csc from "country-state-city";
import moment from "moment";

export const checkAndReplace = (value) => {
    if (value && value.includes("'") == true) {
      // console.log(value.replaceAll("'", "''"));
      return value.replaceAll("'", "''");
    } else {
      return value;
    }
}

export const getFormattedNumber = (value) => {

  if (!value) {
    return ``;
  }
  value = value.replace(/[^\d]/g, '');
    if(value.length <= 0){
      return ``;
    }
    else if(value.length < 4){
      return `(${value}`;
    }
    else if(value.length < 7){
      return `(${value.slice(0,3)}) ${value.slice(3)}`
    }
    else{
      return `(${value.slice(0,3)}) - ${value.slice(3,6)} - ${value.length > 10 ? value.slice(6,10) : value.slice(6)}`
    }
}


export const trimOffTheTop = (value, extraSpaceReplacement) => {
  let extraSpaces = /[[:space:]]{2,}|\t/g;
  return value.replaceAll(extraSpaces, extraSpaceReplacement).trim();
};

export const getVanillaPhoneNumber = (value) => {
  return (
    value.substring(1, 4) + value.substring(8, 11) + value.substring(14, 18)
  );
};

// ---------------------------------------------------------------------------
// Customer Leads trial-detail formatting
//
// Shared by the leads list, the batch-review dialog, and the edit form's
// Trial Details tab so the three views can't drift out of sync.
// ---------------------------------------------------------------------------

export const getCourseName = (courseId, COURSE) =>
  courseId && COURSE
    ? (COURSE.find((c) => c.value == courseId) || {}).name || "—"
    : "—";

export const formatTrialDate = (trialDate, day) =>
  trialDate
    ? `${moment(trialDate).format("MMM D, YYYY")}${day ? ` (${day})` : ""}`
    : "";

export const formatTimeSlot = (startTime, endTime) =>
  startTime && endTime
    ? `${moment(startTime, "HH:mm:ss").format("h:mm a")} – ${moment(endTime, "HH:mm:ss").format("h:mm a")}`
    : "";

export const getLeadsFormattedNumber = (value) =>{
  value = value.replace(/[^\d]/g, '');
  if(value.length <= 0){
    return ``;
  }
  else if(value.length < 4){
    return `(${value})`;
  }
  else if(value.length < 7){
    return `(${value.slice(0,3)}) - ${value.slice(3)}`
  }
  else{
    return `(${value.slice(0,3)}) - ${value.slice(3,6)} - ${value.length > 10 ? value.slice(6,10) : value.slice(6)}`
  }
};

// ---------------------------------------------------------------------------
// Country / state resolution
//
// Saved country/state values across the system come in several spellings that
// never line up with the country-state-city (csc) library the form dropdowns
// use: e.g. country can be an ISO code ("US"), a full name ("United States"),
// or the legacy alias "USA"; the DB country table stores names uppercase
// ("JAMAICA"); and a state can be stored as an ISO code, a name, or a name
// missing csc's suffix ("Kingston" vs csc's "Kingston Parish"). These helpers
// resolve any of those spellings to the canonical csc object so both the
// parent-edit and user-edit forms match consistently instead of crashing or
// silently selecting the wrong option.
// ---------------------------------------------------------------------------

// Curated US state list (50 + DC). Used in place of csc for the US so the
// dropdown excludes territories, matching the long-standing form behaviour.
export const usStates = [
  { name: "Alabama", isoCode: "AL" },
  { name: "Alaska", isoCode: "AK" },
  { name: "Arizona", isoCode: "AZ" },
  { name: "Arkansas", isoCode: "AR" },
  { name: "California", isoCode: "CA" },
  { name: "Colorado", isoCode: "CO" },
  { name: "Connecticut", isoCode: "CT" },
  { name: "Delaware", isoCode: "DE" },
  { name: "District of Columbia", isoCode: "DC" },
  { name: "Florida", isoCode: "FL" },
  { name: "Georgia", isoCode: "GA" },
  { name: "Hawaii", isoCode: "HI" },
  { name: "Idaho", isoCode: "ID" },
  { name: "Illinois", isoCode: "IL" },
  { name: "Indiana", isoCode: "IN" },
  { name: "Iowa", isoCode: "IA" },
  { name: "Kansas", isoCode: "KS" },
  { name: "Kentucky", isoCode: "KY" },
  { name: "Louisiana", isoCode: "LA" },
  { name: "Maine", isoCode: "ME" },
  { name: "Maryland", isoCode: "MD" },
  { name: "Massachusetts", isoCode: "MA" },
  { name: "Michigan", isoCode: "MI" },
  { name: "Minnesota", isoCode: "MN" },
  { name: "Mississippi", isoCode: "MS" },
  { name: "Missouri", isoCode: "MO" },
  { name: "Montana", isoCode: "MT" },
  { name: "Nebraska", isoCode: "NE" },
  { name: "Nevada", isoCode: "NV" },
  { name: "New Hampshire", isoCode: "NH" },
  { name: "New Jersey", isoCode: "NJ" },
  { name: "New Mexico", isoCode: "NM" },
  { name: "New York", isoCode: "NY" },
  { name: "North Carolina", isoCode: "NC" },
  { name: "North Dakota", isoCode: "ND" },
  { name: "Ohio", isoCode: "OH" },
  { name: "Oklahoma", isoCode: "OK" },
  { name: "Oregon", isoCode: "OR" },
  { name: "Pennsylvania", isoCode: "PA" },
  { name: "Rhode Island", isoCode: "RI" },
  { name: "South Carolina", isoCode: "SC" },
  { name: "South Dakota", isoCode: "SD" },
  { name: "Tennessee", isoCode: "TN" },
  { name: "Texas", isoCode: "TX" },
  { name: "Utah", isoCode: "UT" },
  { name: "Vermont", isoCode: "VT" },
  { name: "Virginia", isoCode: "VA" },
  { name: "Washington", isoCode: "WA" },
  { name: "West Virginia", isoCode: "WV" },
  { name: "Wisconsin", isoCode: "WI" },
  { name: "Wyoming", isoCode: "WY" },
];

// Maps non-canonical saved country names to the csc canonical name.
const COUNTRY_NAME_ALIASES = {
  usa: "united states",
  "united states of america": "united states",
};

// Trailing words csc appends to some state/parish names but the DB may omit.
const STATE_SUFFIX_REGEX = /\s+(parish|province|state|county|region|department|district)$/i;
const stripStateSuffix = (name) =>
  String(name || "").trim().replace(STATE_SUFFIX_REGEX, "").trim().toLowerCase();

// Returns the state list for a canonical csc country isoCode. The US uses the
// curated usStates list above; everything else defers to csc.
export const getStateList = (countryIsoCode) =>
  countryIsoCode === "US" ? usStates : csc.getStatesOfCountry(countryIsoCode) || [];

// Resolves a saved country value (isoCode | full name | "USA" alias | any case)
// to the canonical csc country object, or null when nothing matches.
export const resolveCountry = (savedValue) => {
  if (!savedValue) return null;
  const needle = String(savedValue).trim().toLowerCase();
  const countries = csc.getAllCountries();
  return (
    countries.find((c) => c.isoCode.toLowerCase() === needle) ||
    countries.find((c) => c.name.toLowerCase() === needle) ||
    (COUNTRY_NAME_ALIASES[needle]
      ? countries.find((c) => c.name.toLowerCase() === COUNTRY_NAME_ALIASES[needle])
      : null) ||
    null
  );
};

// Resolves a saved state value (isoCode | name | suffix-less name such as
// "Kingston" for csc's "Kingston Parish") to the matching object from
// getStateList, or null when nothing matches. Never falls back to the first
// option, so callers can show a placeholder instead of fabricating a value.
export const resolveState = (countryIsoCode, savedValue) => {
  if (!savedValue) return null;
  const list = getStateList(countryIsoCode);
  const needle = String(savedValue).trim().toLowerCase();
  const match =
    list.find((s) => s.isoCode.toLowerCase() === needle) ||
    list.find((s) => s.name.toLowerCase() === needle);
  if (match) return match;
  const strippedNeedle = stripStateSuffix(savedValue);
  return list.find((s) => stripStateSuffix(s.name) === strippedNeedle) || null;
};